export default __webpack_public_path__ + "static/media/jealous.5388a349.gif";